// Subcategory mapping configuration
// Maps subcategory names/IDs to their icons, display names, descriptions, and related information

export const subcategoryMapping = {
  // Women Salon Subcategories
  Facial: {
    name: "Facial",
    icon: "/images/serviceCard/facial.png",
    displayName: "Facial",
    description: "Professional facial treatments",
    category: "Women Salon",
    color: "#FF6B9D",
    duration: "60-90 min",
    popular: true,
    offerings: ["Deep Cleansing", "Anti-Aging", "Brightening", "Hydrating"],
  },
  "Hair Salon": {
    name: "Hair Salon",
    icon: "/images/serviceCard/hair.png",
    displayName: "Hair Salon",
    description: "Professional hair styling and treatments",
    category: "Women Salon",
    color: "#8B5CF6",
    duration: "90-180 min",
    popular: true,
    offerings: ["Hair Cut", "Hair Color", "Hair Treatment", "Styling"],
  },
  Threading: {
    name: "Threading",
    icon: "/images/serviceCard/threading.png",
    displayName: "Threading",
    description: "Professional eyebrow and facial threading",
    category: "Women Salon",
  },
  Waxing: {
    name: "Waxing",
    icon: "/images/serviceCard/waxing.png",
    displayName: "Waxing",
    description: "Professional body waxing services",
    category: "Women Salon",
  },
  Manicure: {
    name: "Manicure",
    icon: "/images/serviceCard/mani.png",
    displayName: "Manicure",
    description: "Professional nail care and manicure",
    category: "Women Salon",
  },
  Pedicure: {
    name: "Pedicure",
    icon: "/images/serviceCard/pedi.png",
    displayName: "Pedicure",
    description: "Professional foot care and pedicure",
    category: "Women Salon",
  },

  // AC & Appliance Services Subcategories
  "AC Installation": {
    name: "AC Installation",
    icon: "/images/category/ac.svg",
    displayName: "AC Installation",
    description: "Professional air conditioner installation",
    category: "Ac & Appliance Services",
  },
  "AC Servicing & Repair": {
    name: "AC Servicing & Repair",
    icon: "/images/category/ac.svg",
    displayName: "AC Servicing & Repair",
    description: "Expert air conditioner repair services",
    category: "Ac & Appliance Services",
  },
  "AC Maintenance": {
    name: "AC Maintenance",
    icon: "/images/category/ac.svg",
    displayName: "AC Maintenance",
    description: "Regular AC maintenance and servicing",
    category: "Ac & Appliance Services",
  },

  // Cleaning Subcategories
  "Home Cleaning": {
    name: "Home Cleaning",
    icon: "/images/category/cleaning.svg",
    displayName: "Home Cleaning",
    description: "Professional home cleaning services",
    category: "Cleaning",
  },
  "Sofa Cleaning": {
    name: "Sofa Cleaning",
    icon: "/images/category/cleaning.svg",
    displayName: "Sofa Cleaning",
    description: "Professional sofa and upholstery cleaning",
    category: "Cleaning",
  },

  // Appliance Repair Subcategories
  "Refrigerator Repair": {
    name: "Refrigerator Repair",
    icon: "/images/category/refrigerator.svg",
    displayName: "Refrigerator Repair",
    description: "Expert refrigerator repair and maintenance",
    category: "Ac & Appliance Services",
  },
  "Washing Machine Repair": {
    name: "Washing Machine Repair",
    icon: "/images/category/washingMachine.svg",
    displayName: "Washing Machine Repair",
    description: "Professional washing machine repair services",
    category: "Ac & Appliance Services",
  },
  "Microwave & Oven Repair": {
    name: "Microwave & Oven Repair",
    icon: "/images/category/microwave.svg",
    displayName: "Microwave Repair",
    description: "Expert microwave oven repair services",
    category: "Ac & Appliance Services",
  },
  "Geyser Installation & Repair": {
    name: "Geyser Installation & Repair",
    icon: "/images/category/geyser.svg",
    displayName: "Geyser Repair",
    description: "Professional water heater repair and installation",
    category: "Ac & Appliance Services",
  },

  // Other Services
  "Chimney & Hob Repair": {
    name: "Chimney & Hob Repair",
    icon: "/images/category/chimney.svg",
    displayName: "Chimney Cleaning",
    description: "Professional kitchen chimney cleaning services",
    category: "Ac & Appliance Services",
  },
  "Window Repair": {
    name: "Window Repair",
    icon: "/images/category/window.svg",
    displayName: "Window Repair",
    description: "Professional window repair and maintenance",
    category: "HomeFix",
  },
  "Pest Control": {
    name: "Pest Control",
    icon: "/images/category/pestControl.svg",
    displayName: "Pest Control",
    description: "Professional pest control and extermination",
    category: "Pest Control",
    color: "#059669",
    duration: "120-180 min",
    popular: true,
    offerings: [
      "General Pest Control",
      "Cockroach Control",
      "Termite Control",
      "Rodent Control",
    ],
  },
  Plumbing: {
    name: "Plumbing",
    icon: "/images/category/plumbing.svg",
    displayName: "Plumbing",
    description: "Professional plumbing repair and installation",
    category: "HomeFix",
  },
  Electrical: {
    name: "Electrical",
    icon: "/images/category/electrical.svg",
    displayName: "Electrical",
    description: "Professional electrical repair and installation",
  },
  "Kitchen & Utensils Cleaning": {
    name: "Kitchen & Utensils Cleaning",
    icon: "/images/kitchen.svg",
    displayName: "Kitchen & Utensils Cleaning",
    category: "Home Cleaning & Maid Services",
  },
  "Bathroom Deep Cleaning": {
    name: "Bathroom Deep Cleaning",
    icon: "/images/Bathroom.svg",
    displayName: "Bathroom Deep Cleaning",
    category: "Home Cleaning & Maid Services",
  },

  "Floor Cleaning (Jhaadu-Pocha)": {
    name: "Floor Cleaning (Jhaadu-Pocha)",
    icon: "/images/sweeping.svg",
    displayName: "Floor Cleaning (Jhaadu-Pocha)",
    category: "Home Cleaning & Maid Services",
  },
  "Dusting & Fan Cleaning": {
    name: "Dusting & Fan Cleaning",
    icon: "/images/Dusting.svg",
    displayName: "Dusting & Fan Cleaning",
    category: "Home Cleaning & Maid Services",
  },

  "Balcony & Window Cleaning": {
    name: "Balcony & Window Cleaning",
    icon: "/images/Balcony.svg",
    displayName: "Balcony & Window Cleaning",
    category: "Home Cleaning & Maid Services",
  },
  "Laundry & Ironing Services": {
    name: "Laundry & Ironing Services",
    icon: "/images/Laundry.svg",
    displayName: "Laundry & Ironing Services",
    category: "Home Cleaning & Maid Services",
  },
};

// Helper function to get subcategory info by name
export const getSubcategoryInfo = (subcategoryName) => {
  return (
    subcategoryMapping[subcategoryName] || {
      name: subcategoryName,
      icon: "/images/icons8-air-conditioner-48.png", // fallback icon
      displayName: subcategoryName,
      description: "Service subcategory",
      category: "Other",
      color: "#6B7280",
      duration: "60 min",
      popular: false,
      offerings: [],
    }
  );
};

// Helper function to get subcategory info by ID
export const getSubcategoryInfoById = (subcategoryId) => {
  return getSubcategoryInfo(subcategoryId);
};

// Get all subcategory names
export const getAllSubcategoryNames = () => {
  return Object.keys(subcategoryMapping);
};

// Get all subcategory info objects
export const getAllSubcategories = () => {
  return Object.values(subcategoryMapping);
};

// Get subcategories by category
export const getSubcategoriesByCategory = (categoryName) => {
  return Object.values(subcategoryMapping).filter(
    (subcategory) => subcategory.category === categoryName
  );
};

// Check if a subcategory exists
export const subcategoryExists = (subcategoryName) => {
  return subcategoryName in subcategoryMapping;
};

// Get popular subcategories for the bar
export const getPopularSubcategories = () => {
  const popularNames = [
    "Facial",
    "Hair Salon",
    "Threading",
    "Waxing",
    "Manicure",
    "Pedicure",
    "AC Installation",
    "AC Servicing & Repair",
    "Plumbing",
    "Electrical",
    "Home Cleaning",
    "Pest Control",
  ];

  return popularNames.map((name) => ({
    name,
    ...getSubcategoryInfo(name),
  }));
};

// Get subcategory icon by name
export const getSubcategoryIcon = (subcategoryName) => {
  return getSubcategoryInfo(subcategoryName).icon;
};

// Get subcategory display name by name
export const getSubcategoryDisplayName = (subcategoryName) => {
  return getSubcategoryInfo(subcategoryName).displayName;
};

// Get subcategory color by name
export const getSubcategoryColor = (subcategoryName) => {
  return getSubcategoryInfo(subcategoryName).color;
};

// Get subcategory duration by name
export const getSubcategoryDuration = (subcategoryName) => {
  return getSubcategoryInfo(subcategoryName).duration;
};

// Get subcategory offerings by name
export const getSubcategoryOfferings = (subcategoryName) => {
  return getSubcategoryInfo(subcategoryName).offerings;
};
